import { courseConstants } from "../constants/courses"
import { lessonConstants } from "../constants/lessonConstants"
import forOwn from "mout/object/forOwn"
import { find } from "lodash"

const initialState = {
  courses: [],
  getCourseFailure: false,
  fetchingCourse: false,
  courseStatus: false,
  fetchingCourseSubcourses: false,
  subcourses: [],
  sections: [],
  lessons: [],
  subcourseSections: {},
  sectionLessons: {},
  setNode: false,
  creatingLesson: false,
  createdLesson: {}
}

export function courses(state = initialState, action) {
  switch (action.type) {
    case courseConstants.GET_COURSE_FAILURE:
      return {
        ...state,
        getCourseFailure: true,
        fetchingCourse: false,
        courseFetchError: action.error
      }
    case courseConstants.GET_COURSE_REQUEST:
      return {
        ...state,
        fetchingCourse: true
      }
    case courseConstants.GET_COURSE_SUCCESS:
      return {
        ...state,
        fetchingCourse: false,
        course: action.course
      }
    case courseConstants.TOGGLE_COURSE_STATUS_REQUEST:
      return {
        ...state,
        courseStatus: true
      }
    case courseConstants.TOGGLE_COURSE_STATUS_SUCCESS:
      return {
        ...state,
        courseStatus: false,
        course: {
          ...state.course,
          published:
            state.course.id === action.course.id
              ? !action.course.status
              : state.course.published
        }
      }
    case courseConstants.TOGGLE_COURSE_STATUS_FAILURE:
      return {
        ...state,
        courseStatus: false,
        error: action.error
      }
    case courseConstants.GET_COURSE_SUBCOURSES_FAILURE:
      return {
        ...state,
        fetchingCourseSubcourses: false,
        subcourseFetchError: action.error
      }
    case courseConstants.GET_COURSE_SUBCOURSES_REQUEST:
      return {
        ...state,
        fetchingCourseSubcourses: true
      }
    case courseConstants.GET_COURSE_SUBCOURSES_SUCCESS:
      return {
        ...state,
        fetchingCourseSubcourses: false,
        subcourses: action.subcourses
      }
    case courseConstants.CREATE_SUBCOURSE_FAILURE:
      return {
        ...state,
        creatingSubcourse: false
      }
    case courseConstants.CREATE_SUBCOURSE_REQUEST:
      return {
        ...state,
        creatingSubcourse: true
      }
    case courseConstants.CREATE_SUBCOURSE_SUCCESS:
      state.subcourses && state.subcourses.push(action.subcourse.subcourse)
      return {
        ...state,
        course: action.subcourse.course,
        subcourse: action.subcourse,
        creatingSubcourse: false
      }
    case courseConstants.GET_COURSES_REQUEST:
      return {
        ...state,
        fetchingCourse: true
      }
    case courseConstants.GET_COURSES_SUCCESS:
      return {
        ...state,
        fetchingCourse: false,
        courses: action.courses
      }
    case courseConstants.GET_COURSES_FAILURE:
      return {
        ...state,
        fetchingCourse: false,
        error: action.error
      }
    case courseConstants.UPDATE_INDEX_SUBCOURSE_SUCCESS:
      return {
        ...state,
        subcourseIndexes: action.subcourse
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_REQUEST:
      return {
        ...state,
        togglePublishStatus: true
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_SUCCESS:
      state.subcourses.forEach(subcourse => {
        if (subcourse.id === action.subcourse.subcourseId)
          subcourse.published = action.subcourse.status
      })
      return {
        ...state,
        togglePublishStatus: false
      }
    case courseConstants.TOGGLE_SUBCOURSE_STATUS_FAILURE:
      return {
        ...state,
        togglePublishStatus: false,
        error: action.error
      }
    case courseConstants.CREATE_SECTION_FAILURE:
      return {
        ...state,
        creatingSection: false
      }
    case courseConstants.CREATE_SECTION_REQUEST:
      return {
        ...state,
        creatingSection: true
      }
    case courseConstants.CREATE_SECTION_SUCCESS:
      state.subcourses &&
        state.subcourses.forEach(subcourse => {
          if (subcourse.id === action.section.section.subcourseId)
            subcourse.sections = action.section.subcourse.sections
        })
      Object.keys(state.subcourseSections).length > 0
        ? forOwn(state.subcourseSections, (val, subcourse) => {
            if (
              state.subcourseSections[subcourse] &&
              subcourse === action.section.section.subcourseId
            ) {
              val.push(action.section.section)
            }
          })
        : (state.subcourseSections[action.section.section.subcourseId] = [
            action.section.section
          ])

      return {
        ...state,
        createdSection: action.section,
        creatingSection: false
      }
    case courseConstants.GET_SECTION_FAILURE:
      return {
        ...state,
        fetchingSection: false
      }
    case courseConstants.GET_SECTION_REQUEST:
      return {
        ...state,
        fetchingSection: true
      }
    case courseConstants.GET_SECTION_SUCCESS:
      let subcourseSections =
        action.section.length > 0
          ? {
              ...state.subcourseSections,
              [action.section[0].subcourseId]: action.section
            }
          : {}
      return {
        ...state,
        subcourseSections,
        fetchingSection: false
      }

    case courseConstants.GET_LESSON_FAILURE:
      return {
        ...state,
        fetchingLesson: false
      }
    case courseConstants.GET_LESSON_REQUEST_COMPLETE:
      return {
        ...state,
        fetchingLesson: false
      }
    case courseConstants.GET_LESSON_REQUEST:
      return {
        ...state,
        fetchingLesson: true
      }
    case courseConstants.GET_LESSON_SUCCESS:
      let sectionLessons =
        action.lesson.length > 0
          ? {
              ...state.sectionLessons,
              [action.lesson[0].sectionId]: action.lesson
            }
          : {}
      return {
        ...state,
        sectionLessons,
        fetchingLesson: false
      }

    case courseConstants.CREATE_LESSON_FAILURE:
      return {
        ...state,
        creatingLesson: false
      }
    case courseConstants.CREATE_LESSON_REQUEST:
      return {
        ...state,
        creatingLesson: true
      }
    case courseConstants.CREATE_LESSON_SUCCESS:
      Object.keys(state.sectionLessons).length > 0
        ? forOwn(state.sectionLessons, (val, section) => {
            if (
              state.sectionLessons[section] &&
              section === action.lesson.lesson.sectionId
            ) {
              val.push(action.lesson.lesson)
            }
          })
        : (state.sectionLessons[action.lesson.lesson.sectionId] = [
            action.lesson.lesson
          ])

      state.subcourseSections &&
        forOwn(state.subcourseSections, (val, subcourse) => {
          if (subcourse === action.lesson.section.subcourseId) {
            let lesson = find(val, { id: action.lesson.section.id })
            lesson.lessons = action.lesson.section.lessons
          }
        })

      return {
        ...state,
        createdLesson: action.lesson,
        creatingLesson: false
      }

    case courseConstants.SET_NODE_FAILURE:
      return {
        ...state,
        setNodeFailiure: action.error,
        setNode: false
      }
    case courseConstants.SET_NODE_REQUEST:
      return {
        ...state,
        setNode: true
      }
    case courseConstants.SET_NODE_SUCCESS:
      return {
        ...state,
        setNode: false
      }

    case courseConstants.DELETE_SUBCOURSE_FAILURE:
      return {
        ...state,
        deletingSubcourse: false
      }
    case courseConstants.DELETE_SUBCOURSE_SUCCESS:
      let subcourse = state.subcourses.filter(subcourse => {
        if (subcourse.id !== action.subcourse) {
          return subcourse
        }
      })
      return {
        ...state,
        deletingSubcourse: false,
        subcourses: subcourse
      }
    case courseConstants.DELETE_SUBCOURSE_REQUEST:
      return {
        ...state,
        deletingSubcourse: true
      }

    case courseConstants.DELETE_SECTION_FAILURE:
      return {
        ...state,
        deletingSection: false
      }
    case courseConstants.DELETE_SECTION_SUCCESS:
      let section = state.subcourseSections[action.section.subcourseId].filter(
        section => section.id !== action.section.sectionId
      )
      const subcourses = [...state.subcourses]
      subcourses.find(
        subcourse => subcourse.id === action.section.subcourseId
      ).sections[action.section.sectionId] = "-1"
      return {
        ...state,
        deletingSection: false,
        subcourseSections: {
          [action.section.subcourseId]: section
        },
        subcourses
      }
    case courseConstants.DELETE_SECTION_REQUEST:
      return {
        ...state,
        deletingSection: true
      }
    case courseConstants.DELETE_LESSON_FAILURE:
      return {
        ...state,
        deletingLesson: false
      }
    case courseConstants.DELETE_LESSON_SUCCESS:
      let lesson = state.sectionLessons[action.lesson.sectionId].filter(
        lesson => lesson.id !== action.lesson.lessonId
      )
      return {
        ...state,
        deletingLesson: false,
        sectionLessons: {
          [action.lesson.sectionId]: lesson
        }
      }
    case courseConstants.DELETE_LESSON_REQUEST:
      return {
        ...state,
        deletingLesson: true
      }
    case courseConstants.TOGGLE_SECTION_STATUS_REQUEST:
      return {
        ...state,
        togglePublishStatus: true
      }
    case courseConstants.TOGGLE_SECTION_STATUS_SUCCESS:
      state.subcourseSections[action.section["section"].subcourseId].map(
        section => {
          if (section.id === action.section["section"].id) {
            return (section.published = action.section.status)
          } else {
            return
          }
        }
      )
      return {
        ...state,
        togglePublishStatus: false
      }
    case courseConstants.TOGGLE_SECTION_STATUS_FAILURE:
      return {
        ...state,
        togglePublishStatus: false,
        error: action.error
      }

    case lessonConstants.LESSON_DELETE_SUCCESS:
      let sections = state.subcourseSections[action.payload.subcourseId]
      let lessons = state.sectionLessons[action.payload.sectionId]
      let sectionIndex = sections.findIndex(
        section => section.id === action.payload.sectionId
      )
      let lessonIndex = lessons.findIndex(
        lesson => lesson.id === action.payload.lessonId
      )
      if (sectionIndex !== -1) {
        sections[sectionIndex].lessons = action.payload.lessons
      }
      if (lessonIndex !== -1) {
        lessons.splice(lessonIndex, 1)
      }
      return {
        ...state,
        subcourseSections: {
          ...state.subcourseSections,
          [action.payload.subcourseId]: sections
        },
        sectionLessons: {
          ...state.sectionLessons,
          [action.payload.sectionId]: lessons
        }
      }

    default:
      return state
  }
}
